import { CreateDepartmentModalTranslations } from "./types";

export const enTranslations: CreateDepartmentModalTranslations = {
    title: "Create Department",
    name: "Name",
    createButtonText: "Create",
};
